import { createAsyncThunk, createSlice, PayloadAction } from "@reduxjs/toolkit";
import { AgencyTitle } from "../../utilities/interfaces/AgencyTitles";
import { dictionary } from "../../utilities/types/dictionary";
import { chapterAPI } from "../../utilities/api";

interface agencyTitleState {
    agencyTitles: dictionary<AgencyTitle[]>;
  loading: boolean;
  error: string | null
}

const initialState: agencyTitleState = {
        agencyTitles: {},
    loading: false,
    error: null
}

const agencyTitleSlice = createSlice({
    name: 'stateAgencyTitle',
    initialState: initialState,
     reducers: {
        setLoading(state: { loading: boolean; }, action: PayloadAction<boolean>) {
            state.loading = action.payload;
        },
    },
    extraReducers(builder) {
        builder.addCase(GetByTitleId.pending, (state) => {
            state.loading = true;
            state.error = null;
            state.agencyTitles = {};
        });
        builder.addCase(GetByTitleId.rejected, (state, action) => {
            state.loading = false;
            state.error = action.error.message || 'Failed to fetch agency title';
        });
        builder.addCase(GetByTitleId.fulfilled, (state, action: PayloadAction<AgencyTitle[]>) => {
            state.loading = false;
            state.error = null;

            const groupedTitles = action.payload.reduce((acc, item) => {
                const key = item.id.toString();
                if (!acc[key]) {
                    acc[key] = [];
                }
                acc[key].push(item);
                return acc;
            }, {} as dictionary<AgencyTitle[]>);

            state.agencyTitles = groupedTitles;

        });

    }
});



export const GetByTitleId = createAsyncThunk<AgencyTitle[], number>('stateAgencyTitle/getByTitleId',
     async (id: number) => {
    const response = await chapterAPI.getChaptersByTitleId(id) as AgencyTitle[];
    return response;
});

export const { setLoading } = agencyTitleSlice.actions;
export default agencyTitleSlice.reducer;